import { FinanceOptionFields, SearchFieldMap, SearchFieldMapGroup, SearchFieldType } from './search-fields-map.types'

export const postcode: SearchFieldMap = {
    name: 'postcode',
    label: 'Postcode',
    placeholder: 'Enter a Postcode',
    dispatchEvent: 'selectPostcode',
    type: SearchFieldType.input,
}

export const distance: SearchFieldMap = {
    name: 'distance',
    facetName: 'distance',
    label: 'Distance',
    placeholder: 'National',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const make: SearchFieldMap = {
    name: 'make',
    facetName: 'make',
    label: 'Make',
    placeholder: 'Any',
    dispatchEvent: 'updateArrayStringSelect',
    type: SearchFieldType.select,
}
export const model: SearchFieldMap = {
    name: 'model',
    facetName: 'model',
    label: 'Model',
    placeholder: 'Any',
    dispatchEvent: 'updateArrayStringSelect',
    type: SearchFieldType.select,
    dependancy: 'make',
}

export const modelVariant: SearchFieldMap = {
    name: 'aggregatedTrim',
    facetName: 'aggregated_trim',
    label: 'Model variant',
    placeholder: 'Any',
    dispatchEvent: 'updateArrayStringSelect',
    type: SearchFieldType.select,
    dependancy: 'model',
    trackingLabel: 'model variant',
}
export const bodyType: SearchFieldMap = {
    name: 'bodyType',
    facetName: 'body_type',
    label: 'Body type',
    placeholder: 'Body Type (any)',
    dispatchEvent: 'updateArrayStringSelect',
    type: SearchFieldType.bodyType,
}

export const berth: SearchFieldMap = {
    name: 'berth',
    facetName: 'berth',
    label: 'Berth',
    placeholder: 'Any',
    dispatchEvent: 'updateArrayStringSelect',
    type: SearchFieldType.select,
}

export const fuelType: SearchFieldMap = {
    name: 'fuelType',
    facetName: 'fuel_type',
    label: 'Fuel type',
    placeholder: 'Any',
    dispatchEvent: 'updateArrayStringSelect',
    type: SearchFieldType.multiselect,
}
export const colour: SearchFieldMap = {
    name: 'colour',
    facetName: 'colour',
    label: 'Colour',
    placeholder: 'Any',
    dispatchEvent: 'updateArrayStringSelect',
    type: SearchFieldType.multiselect,
}

export const minPrice: SearchFieldMap = {
    name: 'minPrice',
    facetName: 'min_price',
    label: 'Min price',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const maxPrice: SearchFieldMap = {
    name: 'maxPrice',
    facetName: 'max_price',
    label: 'Max price',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const minSuppliedPrice: SearchFieldMap = {
    name: 'minSuppliedPrice',
    facetName: 'min_supplied_price',
    label: 'Min price',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const maxSuppliedPrice: SearchFieldMap = {
    name: 'maxSuppliedPrice',
    facetName: 'max_supplied_price',
    label: 'Max price',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const minMonthlyPrice: SearchFieldMap = {
    name: 'minMonthlyPrice',
    facetName: 'min_monthly_price',
    label: 'Min price',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const maxMonthlyPrice: SearchFieldMap = {
    name: 'maxMonthlyPrice',
    facetName: 'max_monthly_price',
    label: 'Max price',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const minYear: SearchFieldMap = {
    name: 'minYear',
    facetName: 'min_year_manufactured',
    label: 'Min year',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const maxYear: SearchFieldMap = {
    name: 'maxYear',
    facetName: 'max_year_manufactured',
    label: 'Max year',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const transmission: SearchFieldMap = {
    name: 'transmission',
    facetName: 'transmission',
    label: 'Gearbox',
    placeholder: 'Any',
    dispatchEvent: 'updateArrayStringSelect',
    type: SearchFieldType.select,
}

export const mileage: SearchFieldMap = {
    name: 'maxMileage',
    facetName: 'max_mileage',
    label: 'Mileage',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const minEngineSize: SearchFieldMap = {
    name: 'minEngineSizeLitres',
    facetName: 'min_engine_size',
    label: 'Min engine size',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const maxEngineSize: SearchFieldMap = {
    name: 'maxEngineSizeLitres',
    facetName: 'max_engine_size',
    label: 'Max engine size',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const sellerType: SearchFieldMap = {
    name: 'sellerType',
    facetName: 'seller_type',
    label: 'Private & trade',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const doors: SearchFieldMap = {
    name: 'doorsValue',
    facetName: 'doors_values',
    label: 'Doors',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const minSeats: SearchFieldMap = {
    name: 'minSeats',
    facetName: 'min_seats',
    label: 'Min seats',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const maxSeats: SearchFieldMap = {
    name: 'maxSeats',
    facetName: 'max_seats',
    label: 'Max seats',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const bootSpace: SearchFieldMap = {
    name: 'bootSizeValues',
    facetName: 'boot_size_values',
    label: 'Boot space',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const acceleration: SearchFieldMap = {
    name: 'accelerationValue',
    facetName: 'acceleration_values',
    label: 'Acceleration',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const annualTax: SearchFieldMap = {
    name: 'annualTaxValue',
    facetName: 'annual_tax_values',
    label: 'Annual tax',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const drivetrain: SearchFieldMap = {
    name: 'drivetrain',
    facetName: 'drivetrain',
    label: 'Drivetrain',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const fuelConsumption: SearchFieldMap = {
    name: 'fuelConsumptionValue',
    facetName: 'fuel_consumption_values',
    label: 'Fuel consumption',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const insurance: SearchFieldMap = {
    name: 'maxInsuranceGroup',
    facetName: 'max_insurance_group',
    label: 'Insurance group',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const carbonEmissions: SearchFieldMap = {
    name: 'co2EmissionValue',
    facetName: 'co2_emission_values',
    label: 'CO2 emissions',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const writeOffCategory: SearchFieldMap = {
    name: 'showWriteOff',
    facetName: 'is_writeoff',
    label: 'Cat S/C/D/N',
    placeholder: 'Include Cat S/C/D/N',
    dispatchEvent: 'updateWriteoff',
    type: SearchFieldType.select,
}

export const keywords: SearchFieldMap = {
    name: 'keywords',
    label: 'Add keywords',
    placeholder: 'e.g. sunroof, sat nav',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.input,
}

export const dealsOnly: SearchFieldMap = {
    name: 'deals',
    facetName: 'with_manufacturer_rrp_saving',
    label: 'Only show new car deals',
    placeholder: '',
    dispatchEvent: 'updateBoolean',
    type: SearchFieldType.pushSwitch,
}

export const northernIreland: SearchFieldMap = {
    name: 'postalRegion',
    facetName: 'postal_region',
    label: 'Northern Ireland adverts only',
    placeholder: '',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.singleCheckbox,
    trackingLabel: 'northern ireland adverts',
}

export const manufacturerApproved: SearchFieldMap = {
    name: 'isManufacturerApproved',
    facetName: 'is_manufacturer_approved',
    label: 'Manufacturer approved',
    placeholder: '',
    dispatchEvent: 'updateBoolean',
    type: SearchFieldType.singleCheckbox,
    trackingLabel: 'manufacturer approved',
}

export const additionalAds: SearchFieldMap = {
    name: 'advertClassification',
    facetName: 'advert_classification',
    label: 'Additional ads',
    placeholder: '',
    dispatchEvent: 'updateArrayStringSelect',
    type: SearchFieldType.singleCheckbox,
    trackingLabel: 'additional ads',
}

export const batteryRangeValues: SearchFieldMap = {
    name: 'batteryRangeValue',
    facetName: 'battery_range_values',
    label: 'Battery range',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const batteryChargeTimeValues: SearchFieldMap = {
    name: 'batteryChargeTimeValue',
    facetName: 'battery_charge_time_values',
    label: 'Battery charge time',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const batteryQuickChargeTimeValues: SearchFieldMap = {
    name: 'batteryQuickChargeTimeValue',
    facetName: 'battery_quick_charge_time_values',
    label: 'Battery quick charge time',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const cabType: SearchFieldMap = {
    name: 'cabType',
    facetName: 'cab_type',
    label: 'Cab type',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const wheelbase: SearchFieldMap = {
    name: 'wheelbase',
    facetName: 'wheelbase',
    label: 'Wheelbase',
    placeholder: 'Any',
    dispatchEvent: 'updateStringSelect',
    type: SearchFieldType.select,
}

export const minBHP: SearchFieldMap = {
    name: 'minEnginePower',
    facetName: 'min_engine_power',
    label: 'Min engine power',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const maxBHP: SearchFieldMap = {
    name: 'maxEnginePower',
    facetName: 'max_engine_power',
    label: 'Max engine power',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const minCC: SearchFieldMap = {
    name: 'minEngineSizeCC',
    facetName: 'min_engine_size_cc',
    label: 'Min CC',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const maxCC: SearchFieldMap = {
    name: 'maxEngineSizeCC',
    facetName: 'max_engine_size_cc',
    label: 'Max CC',
    placeholder: 'Any',
    dispatchEvent: 'updateNumberSelect',
    type: SearchFieldType.select,
}

export const partExchangeAvailable: SearchFieldMap = {
    name: 'partExAvailable',
    facetName: 'part_exchange_available',
    label: 'Part-exchange guide',
    placeholder: '',
    dispatchEvent: 'updateBoolean',
    type: SearchFieldType.singleCheckbox,
    trackingLabel: 'part-exchange available',
}

export const financeMileage: FinanceOptionFields = {
    name: 'mileage',
    label: 'Mileage (per year)',
    facet: 'finance_option_mileages',
    type: SearchFieldType.select,
}

export const financeDeposit: FinanceOptionFields = {
    name: 'deposit',
    label: 'Deposit',
    facet: 'finance_option_deposits',
    type: SearchFieldType.select,
}

export const financeTerm: FinanceOptionFields = {
    name: 'term',
    label: 'Term (months)',
    facet: 'finance_option_terms',
    type: SearchFieldType.toggle,
}

export const endLayout: SearchFieldMap = {
    name: 'endLayout',
    facetName: 'end_layout',
    label: 'End layout',
    placeholder: 'Any',
    type: SearchFieldType.select,
    dispatchEvent: 'updateStringSelect',
}

export const driverPosition: SearchFieldMap = {
    name: 'driverPosition',
    facetName: 'driver_position',
    label: 'Driver position',
    placeholder: 'Any',
    type: SearchFieldType.select,
    dispatchEvent: 'updateStringSelect',
}

export const minLength: SearchFieldMap = {
    name: 'minExteriorLength',
    facetName: 'min_exterior_length',
    label: 'Min Length',
    placeholder: 'Any',
    type: SearchFieldType.select,
    dispatchEvent: 'updateNumberSelect',
}

export const maxLength: SearchFieldMap = {
    name: 'maxExteriorLength',
    facetName: 'max_exterior_length',
    label: 'Max Length',
    placeholder: 'Any',
    type: SearchFieldType.select,
    dispatchEvent: 'updateNumberSelect',
}

export const sellerDefinedUsed: SearchFieldMap = {
    name: 'isSellerDefinedUsed',
    facetName: 'is_seller_defined_used',
    label: 'New & Used',
    placeholder: 'Any',
    type: SearchFieldType.select,
    dispatchEvent: 'updateBooleanSelect',
}

export const style: SearchFieldMap = {
    name: 'style',
    facetName: 'style',
    label: 'Category',
    placeholder: 'Any',
    type: SearchFieldType.select,
    dispatchEvent: 'updateStringSelect',
}

export const bedroomLayout: SearchFieldMap = {
    name: 'bedroomLayout',
    facetName: 'bedroom_layout',
    label: 'Bedroom layout',
    placeholder: 'Any',
    type: SearchFieldType.select,
    dispatchEvent: 'updateStringSelect',
}

export const minMTPLM: SearchFieldMap = {
    name: 'minMTPLM',
    facetName: 'min_mtplm',
    label: 'Min MTPLM',
    placeholder: 'Any',
    type: SearchFieldType.select,
    dispatchEvent: 'updateNumberSelect',
}

export const maxMTPLM: SearchFieldMap = {
    name: 'maxMTPLM',
    facetName: 'max_mtplm',
    label: 'Max MTPLM',
    placeholder: 'Any',
    type: SearchFieldType.select,
    dispatchEvent: 'updateNumberSelect',
}

export const trailerAxle: SearchFieldMap = {
    name: 'trailerAxleNumber',
    facetName: 'trailer_axle_number',
    label: 'Axles',
    placeholder: 'Any',
    type: SearchFieldType.select,
    dispatchEvent: 'updateNumberSelect',
}

export const guaranteedPartEx: SearchFieldMap = {
    name: 'capabilities',
    facetName: 'capability',
    capability: 'GUARANTEED_PART_EX',
    label: 'Part-ex price guarantee',
    placeholder: '',
    dispatchEvent: 'updateCapability',
    type: SearchFieldType.capabilitiyCheckbox,
    trackingLabel: 'part-ex price guarantee',
}

export const withDigitalRetailing: SearchFieldMap = {
    name: 'withDigitalRetailing',
    facetName: 'with_digital_retailing',
    label: 'Digital retailing',
    placeholder: '',
    dispatchEvent: 'updateBoolean',
    type: SearchFieldType.singleCheckbox,
}

export const locationFields: Array<SearchFieldMap> = [postcode, distance]

export const financeOptions = [financeDeposit, financeTerm, financeMileage]

export const carSearchFields: SearchFieldMapGroup = {
    postcode,
    distance,
    make,
    model,
    modelVariant,
    minPrice,
    maxPrice,
    minMonthlyPrice,
    maxMonthlyPrice,
    minYear,
    maxYear,
    dealsOnly,
    mileage,
    transmission,
    fuelType,
    batteryRangeValues,
    batteryChargeTimeValues,
    batteryQuickChargeTimeValues,
    bodyType,
    minEngineSize,
    maxEngineSize,
    sellerType,
    doors,
    colour,
    minSeats,
    maxSeats,
    bootSpace,
    acceleration,
    annualTax,
    drivetrain,
    fuelConsumption,
    insurance,
    carbonEmissions,
    writeOffCategory,
    keywords,
    northernIreland,
    manufacturerApproved,
    additionalAds,
    guaranteedPartEx,
    withDigitalRetailing,
}

export const vansSearchFields: SearchFieldMapGroup = {
    postcode,
    distance,
    make,
    model,
    bodyType,
    minSuppliedPrice,
    maxSuppliedPrice,
    minMonthlyPrice,
    maxMonthlyPrice,
    minYear,
    maxYear,
    mileage,
    minEngineSize,
    maxEngineSize,
    wheelbase,
    transmission,
    minSeats,
    maxSeats,
    colour,
    doors,
    fuelType,
    fuelConsumption,
    carbonEmissions,
    cabType,
    sellerType,
    keywords,
    writeOffCategory,
    minBHP,
    maxBHP,
    manufacturerApproved,
}
